module.exports = __webpack_public_path__ + "img/BDI.f113cb78.gif";